import React, { useState, useEffect } from "react";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import FooterHomePage from "../../components/footerHomePage/footerHomePage";
import GrillUserToUpdate from "../../components/AlertsComponent/UsersToUpdate/UsersToUpdate";
import GrillaDocument from "../../components/AlertsComponent/DocumentExpires/DocumentExpires";
import FundsHigh from "../../components/AlertsComponent/FundsHigherThanCurrently/FundsHigherThanCurrently";
import BackGroundAlert from "../../components/AlertsComponent/BackgroundAlert/BackGroundAlert";
import Loader from "../../components/AlertsComponent/LoaderAlert/LoaderAlert";
import axios from "axios";
import "./Alert.css";
import Swal from "sweetalert2";

const AlertsL = () => {
  // eslint-disable-next-line
  const [alertMessage, setAlertMessage] = useState([]);
  const [LoaderTrueFalse, setLoaderTrueFalse] = useState(false);
  const [AlertUser, setAlertUser] = useState([]);
  const [alertDocument, setAlertDocument] = useState([]);
  const [AlertfundA, setfundAlerts] = useState([]);
  const [viewAlert, setViewAlert] = useState("");
  const [setStatusAlert] = useState(false);

  useEffect(() => {
    setAlertMessage([]);
    setLoaderTrueFalse(true);
    const fetchData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_LEALTAD_ALERTS_API}`);
        // Mapeamos la respuesta para unificar dni y cuit bajo id
        const usersToUpdate = res.data.entitiesToUpdate.map((user) => {
          const id = user.dni || user.cuit;
          const typeDocument =
            user.entityType === "Persona Humana" ? "DNI" : "CUIT";
          return {
            id,
            status: user.status,
            updateAt: user.updateAt,
            currentDate: user.currentDate,
            entityType: user.entityType,
            typeDocument,
            type: user.risk,
          };
        });

        const alerts = res.data.alerts;
        const alertsUser = res.data.entitiesToUpdate;
        const fundAlerts = res.data.fundAlerts;
        setAlertDocument(alerts);
        setfundAlerts(fundAlerts);
        setAlertMessage(usersToUpdate);
        setAlertUser(alertsUser);
        if (res.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Correcto",
            text: "Los usuarios fueron revisados correctamente",
          });
        }
        setLoaderTrueFalse(false);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Parece que algo salio mal",
        });
      }
      setLoaderTrueFalse(false);
    };

    fetchData();
  }, [setAlertMessage, setStatusAlert]);

  return (
    <div className="all-lealtad">
      <HeaderLogoIcon />
      <div className="header-change-view-alerts-lealtad">
        <button
          className="button-list-alerts-lealtad"
          type="button"
          onClick={(e) => setViewAlert("ListaUser")}
        >
          Usuarios por actualizar
        </button>
        <button
          className="button-list-alerts-lealtad"
          type="button"
          onClick={(e) => setViewAlert("DocumentUser")}
        >
          Documentacion a vencer
        </button>
        <button
          className="button-list-alerts-lealtad"
          type="button"
          onClick={(e) => setViewAlert("FundAuthorized")}
        >
          Fondos superiores al autorizado
        </button>
      </div>
      <div className="box-grill-lealtad">
        {LoaderTrueFalse === true ? <Loader /> : null}
        {viewAlert === "" ? (
          <BackGroundAlert />
        ) : viewAlert === "ListaUser" ? (
          <GrillUserToUpdate data={AlertUser} />
        ) : viewAlert === "DocumentUser" ? (
          <GrillaDocument data={alertDocument} />
        ) : (
          <FundsHigh data={AlertfundA} />
        )}
      </div>
      <FooterHomePage />
    </div>
  );
};

export default AlertsL;
